import { render, staticRenderFns } from "./slider_moves.vue?vue&type=template&id=131130a2&"
import script from "./slider_moves.vue?vue&type=script&lang=js&"
export * from "./slider_moves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports